<p-fieldset legend="Tipo de Obra ou Serviço de Engenharia">
  <div class="row mt-2">
    <div class="col-6">
      <div class="checkbox checbox-switch switch-primary">
        <label>
          <input [(ngModel)]="tipo.AssessoriasConsultoriasTecnicas" [ngModelOptions]="{standalone: true}"
            type="checkbox" />
          <span></span>
          Assessorias ou consultorias técnicas
        </label>
      </div>
    </div>
    <div class="col-6">
      <div class="checkbox checbox-switch switch-primary">
        <label>
          <input [(ngModel)]="tipo.AuditoriaObrasServicosEngenharia" [ngModelOptions]="{standalone: true}"
            type="checkbox" />
          <span></span>
          Auditoria de Obras e Serviços de Engenharia
        </label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <p-fieldset legend="Conserto, instalação ou manutenção em:">
        <div class="row mt-2">
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConsertoInstalacaoManutencaoEm.elevadores10"
                  [ngModelOptions]="{standalone: true}" type="checkbox" />
                <span></span>
                Elevadores e escadas rolantes
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConsertoInstalacaoManutencaoEm.instalacaoEletrica9"
                  [ngModelOptions]="{standalone: true}" type="checkbox" />
                <span></span>
                Instalações elétricas, de iluminação, hidrossanitárias, de águas pluviais, de sonorização ambiente, de
                comunicação e dados
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConsertoInstalacaoManutencaoEm.paisagismo13"
                  [ngModelOptions]="{standalone: true}" type="checkbox" />
                <span></span>
                Paisagismo
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConsertoInstalacaoManutencaoEm.sinalizacao3"
                  [ngModelOptions]="{standalone: true}" type="checkbox" />
                <span></span>
                Sinalização horizontal e vertical de vias públicas ou rodovias
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConsertoInstalacaoManutencaoEm.alarmes5" [ngModelOptions]="{standalone: true}"
                  type="checkbox" />
                <span></span>
                Sistemas de alarmes em edificações
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConsertoInstalacaoManutencaoEm.climatizacao11"
                  [ngModelOptions]="{standalone: true}" type="checkbox" />
                <span></span>
                Sistemas de climatização e ar condicionado
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConsertoInstalacaoManutencaoEm.incendio21"
                  [ngModelOptions]="{standalone: true}" type="checkbox" />
                <span></span>
                Sistemas de combate a incêndio
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConsertoInstalacaoManutencaoEm.controleAcesso14"
                  [ngModelOptions]="{standalone: true}" type="checkbox" />
                <span></span>
                Sistemas de controle de acesso ou circuito fechado de televisão
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConsertoInstalacaoManutencaoEm.protecaoDescargas16"
                  [ngModelOptions]="{standalone: true}" type="checkbox" />
                <span></span>
                Sistemas de proteção contra descargas atmosféricas
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConsertoInstalacaoManutencaoEm.supervisao2"
                  [ngModelOptions]="{standalone: true}" type="checkbox" />
                <span></span>
                Sistemas de supervisão e automação predial
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConsertoInstalacaoManutencaoEm.telefonia6"
                  [ngModelOptions]="{standalone: true}" type="checkbox" />
                <span></span>
                Sistemas de telefonia e comunicação de dados
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConsertoInstalacaoManutencaoEm.ventilacao7"
                  [ngModelOptions]="{standalone: true}" type="checkbox" />
                <span></span>
                Sistemas de ventilação e exaustão
              </label>
            </div>
          </div>
        </div>
      </p-fieldset>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-12">
      <p-fieldset legend="Conservação, reparação ou manutenção de:">
        <div class="row mt-2">
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConservacaoReparacaoManutencaoDe.adultoras18"
                  [ngModelOptions]="{standalone: true}" type="checkbox" />
                <span></span>
                Adutoras, estações de tratamento e redes de distribuição de água
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConservacaoReparacaoManutencaoDe.barragens17"
                  [ngModelOptions]="{standalone: true}" type="checkbox" />
                <span></span>
                Barragens
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConservacaoReparacaoManutencaoDe.edificacoes20"
                  [ngModelOptions]="{standalone: true}" type="checkbox" />
                <span></span>
                Edificações
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConservacaoReparacaoManutencaoDe.obrasSaneamento8"
                  [ngModelOptions]="{standalone: true}" type="checkbox" />
                <span></span>
                Obras de saneamento, drenagem e irrigação
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConservacaoReparacaoManutencaoDe.pontes4" [ngModelOptions]="{standalone: true}"
                  type="checkbox" />
                <span></span>
                Pontes e viadutos
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConservacaoReparacaoManutencaoDe.rodovias12"
                  [ngModelOptions]="{standalone: true}" type="checkbox" />
                <span></span>
                Rodovias
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConservacaoReparacaoManutencaoDe.tratamento19"
                  [ngModelOptions]="{standalone: true}" type="checkbox" />
                <span></span>
                Sistemas de tratamento de resíduos sólidos, incluindo aterros sanitários e usinas de compostagem
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConservacaoReparacaoManutencaoDe.trilho1" [ngModelOptions]="{standalone: true}"
                  type="checkbox" />
                <span></span>
                Trilhos e Veículos sobre Trilhos
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConservacaoReparacaoManutencaoDe.tuneis22"
                  [ngModelOptions]="{standalone: true}" type="checkbox" />
                <span></span>
                Túneis
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConservacaoReparacaoManutencaoDe.vias15" [ngModelOptions]="{standalone: true}"
                  type="checkbox" />
                <span></span>
                Vias públicas
              </label>
            </div>
          </div>
        </div>
      </p-fieldset>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-12">
      <p-fieldset legend="Construção, reforma ou ampliação de:">
        <div class="row mt-2">
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConstrucaoReformaAmpliacaoDe.adultoras18" [ngModelOptions]="{standalone: true}"
                  type="checkbox" />
                <span></span>
                Adutoras, estações de tratamento e redes de distribuição de água
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConstrucaoReformaAmpliacaoDe.barragens17" [ngModelOptions]="{standalone: true}"
                  type="checkbox" />
                <span></span>
                Barragens
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConstrucaoReformaAmpliacaoDe.edificacoes20"
                  [ngModelOptions]="{standalone: true}" type="checkbox" />
                <span></span>
                Edificações
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConstrucaoReformaAmpliacaoDe.obrasSaneamento8"
                  [ngModelOptions]="{standalone: true}" type="checkbox" />
                <span></span>
                Obras de saneamento, drenagem e irrigação
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConstrucaoReformaAmpliacaoDe.pontes4" [ngModelOptions]="{standalone: true}"
                  type="checkbox" />
                <span></span>
                Pontes e viadutos
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConstrucaoReformaAmpliacaoDe.rodovias12" [ngModelOptions]="{standalone: true}"
                  type="checkbox" />
                <span></span>
                Rodovias
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConstrucaoReformaAmpliacaoDe.tratamento19"
                  [ngModelOptions]="{standalone: true}" type="checkbox" />
                <span></span>
                Sistemas de tratamento de resíduos sólidos, incluindo aterros sanitários e usinas de compostagem
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConstrucaoReformaAmpliacaoDe.trilho1" [ngModelOptions]="{standalone: true}"
                  type="checkbox" />
                <span></span>
                Trilhos e Veículos sobre Trilhos
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConstrucaoReformaAmpliacaoDe.tuneis22" [ngModelOptions]="{standalone: true}"
                  type="checkbox" />
                <span></span>
                Túneis
              </label>
            </div>
          </div>
          <div class="col-6">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input [(ngModel)]="tipo.ConstrucaoReformaAmpliacaoDe.vias15" [ngModelOptions]="{standalone: true}"
                  type="checkbox" />
                <span></span>
                Vias públicas
              </label>
            </div>
          </div>
        </div>
      </p-fieldset>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-6">
      <div class="checkbox checbox-switch switch-primary">
        <label>
          <input [(ngModel)]="tipo.ElaboracaoProjetoBasicoProjetoExecutivo" [ngModelOptions]="{standalone: true}"
            type="checkbox" />
          <span></span>
          Elaboração de Projeto Básico ou Projeto Executivo
        </label>
      </div>
    </div>
    <div class="col-6">
      <div class="checkbox checbox-switch switch-primary">
        <label>
          <input [(ngModel)]="tipo.EnsaiosTecnologicos" [ngModelOptions]="{standalone: true}" type="checkbox" />
          <span></span>
          Ensaios tecnológicos
        </label>
      </div>
    </div>
    <div class="col-6">
      <div class="checkbox checbox-switch switch-primary">
        <label>
          <input [(ngModel)]="tipo.EstudosImpactoAmbiental" [ngModelOptions]="{standalone: true}" type="checkbox" />
          <span></span>
          Estudos de Impacto Ambiental
        </label>
      </div>
    </div>
    <div class="col-6">
      <div class="checkbox checbox-switch switch-primary">
        <label>
          <input [(ngModel)]="tipo.EstudosViabilidadeTecnicaEconomica" [ngModelOptions]="{standalone: true}"
            type="checkbox" />
          <span></span>
          Estudos de Viabilidade Técnica e Econômica
        </label>
      </div>
    </div>
    <div class="col-6">
      <div class="checkbox checbox-switch switch-primary">
        <label>
          <input [(ngModel)]="tipo.LevantamentoAerofotogrametrico" [ngModelOptions]="{standalone: true}"
            type="checkbox" />
          <span></span>
          Levantamento aerofotogramétrico
        </label>
      </div>
    </div>
    <div class="col-6">
      <div class="checkbox checbox-switch switch-primary">
        <label>
          <input [(ngModel)]="tipo.LevantamentosTopograficosBatimetricosGeodesicos"
            [ngModelOptions]="{standalone: true}" type="checkbox" />
          <span></span>
          Levantamentos topográficos, batimétricos e geodésicos
        </label>
      </div>
    </div>
    <div class="col-6">
      <div class="checkbox checbox-switch switch-primary">
        <label>
          <input [(ngModel)]="tipo.Outros" [ngModelOptions]="{standalone: true}" type="checkbox" />
          <span></span>
          Outros
        </label>
      </div>
    </div>
    <div class="col-6">
      <div class="checkbox checbox-switch switch-primary">
        <label>
          <input [(ngModel)]="tipo.PericiasAvaliacoes" [ngModelOptions]="{standalone: true}" type="checkbox" />
          <span></span>
          Perícias e avaliações
        </label>
      </div>
    </div>
    <div class="col-6">
      <div class="checkbox checbox-switch switch-primary">
        <label>
          <input [(ngModel)]="tipo.SondagensOutrosProcedimentosInvestigacaoGeotecnica"
            [ngModelOptions]="{standalone: true}" type="checkbox" />
          <span></span>
          Sondagens ou outros procedimentos de investigação geotécnica
        </label>
      </div>
    </div>
  </div>
</p-fieldset>